"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _store = _interopRequireDefault(require("store"));
var _global = _interopRequireDefault(require("global"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../constants");
var _Desktop = _interopRequireDefault(require("./components/Desktop/Desktop"));
var _Mobile = _interopRequireDefault(require("./components/Mobile/Mobile"));
var _config = require("../../content/config");
var _envConstants = require("../../env-constants");
var _MediaContext = require("../MediaContext/MediaContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Navbar = /*#__PURE__*/function (_Component) {
  function Navbar() {
    var _this;
    (0, _classCallCheck2["default"])(this, Navbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Navbar, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      prevScrollpos: _global["default"].pageYOffset,
      visible: true
    });
    (0, _defineProperty2["default"])(_this, "handleScroll", function () {
      var prevScrollpos = _this.state.prevScrollpos;
      var currentScrollPos = _global["default"].pageYOffset;
      // we don't need to measure here height of the nav, because it's static (150)
      var visible = prevScrollpos > currentScrollPos || currentScrollPos < 150;
      _this.setState({
        prevScrollpos: currentScrollPos,
        visible: visible
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(Navbar, _Component);
  return (0, _createClass2["default"])(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        sticky = _this$props.sticky,
        isNavbarFixed = _this$props.isNavbarFixed;
      this.fetchUser();
      if (sticky && !isNavbarFixed) {
        _global["default"].addEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
        sticky = _this$props2.sticky,
        isNavbarFixed = _this$props2.isNavbarFixed;
      if (sticky && !isNavbarFixed) {
        _global["default"].removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "fetchUser",
    value: function () {
      var _fetchUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var user;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_global["default"].location.host === 'localhost:3000')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              user = _store["default"].get('user');
              if (user) {
                this.setState({
                  user: user
                });
              }
              _context.prev = 4;
              _context.next = 7;
              return fetch('/api/profile', {
                credentials: 'same-origin'
              }).then(function (response) {
                return response.json();
              }).then(function (response) {
                if (response.status === 'success') {
                  return response.data;
                }
                return null;
              });
            case 7:
              user = _context.sent;
              if (user !== null) {
                _store["default"].set('user', user);
              } else {
                _store["default"].remove('user');
                _store["default"].remove('reduxPersist:user');
              }
              this.setState({
                user: user
              });
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              console.warn('Couldnt fetch the current user', _context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 12]]);
      }));
      function fetchUser() {
        return _fetchUser.apply(this, arguments);
      }
      return fetchUser;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        user = _this$state.user,
        visible = _this$state.visible;
      var _this$props3 = this.props,
        sticky = _this$props3.sticky,
        logoSite = _this$props3.logoSite,
        isNavbarFixed = _this$props3.isNavbarFixed,
        isNavbarTransparent = _this$props3.isNavbarTransparent;
      var logoConfig = _config.logo[logoSite || _envConstants.ENV.SITE];
      var homePath = this.props.homePath || "/".concat(_envConstants.ENV.SITE === 'tyw' ? 'browse' : 'book');
      var navbarConfig = this.props.navbarConfig || _config.navbar[_envConstants.ENV.SITE];
      return /*#__PURE__*/_react["default"].createElement("nav", {
        className: (0, _classnames["default"])('d8-c-navbar', !visible && '--hidden', sticky && '--sticky', isNavbarTransparent && '--transparent', isNavbarFixed && '--fixed')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "container padding-y-xxs"
      }, /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
        lessThan: _constants.BREAKPOINTS.MD
      }, /*#__PURE__*/_react["default"].createElement(_Mobile["default"], (0, _extends2["default"])({}, this.props, {
        logo: logoConfig,
        links: navbarConfig.mobileLinks,
        user: user,
        homePath: homePath
      }))), /*#__PURE__*/_react["default"].createElement(_MediaContext.Media, {
        greaterThanOrEqual: _constants.BREAKPOINTS.MD
      }, /*#__PURE__*/_react["default"].createElement(_Desktop["default"], (0, _extends2["default"])({}, this.props, {
        logo: logoConfig,
        links: navbarConfig.links,
        user: user,
        homePath: homePath
      })))));
    }
  }]);
}(_react.Component);
Navbar.propTypes = {
  currencyHidden: _propTypes["default"].bool,
  sticky: _propTypes["default"].bool,
  template: _propTypes["default"].string,
  logoSite: _propTypes["default"].string,
  homePath: _propTypes["default"].string,
  isNavbarFixed: _propTypes["default"].bool,
  isNavbarTransparent: _propTypes["default"].bool,
  currentPath: _propTypes["default"].string,
  isPoweredBy: _propTypes["default"].bool,
  navbarConfig: _propTypes["default"].object
};
Navbar.defaultProps = {
  sticky: true,
  logoSite: null,
  homePath: null
};
var _default = exports["default"] = Navbar;